import React from 'react'
import { useMainContext } from '../callContext/MainContext'
const Tabs = ({setCurrentTab,tabShowing, setTabShowing,allTabs}) => {
    const {language}=useMainContext();
   
  return (
    <>
    <div className=' custom-gray max-w-[500px] -mt-1 w-full z-[500] h-shadow '>
       <div className="grid grid-cols-3 card-shadow ">          
              {allTabs?.map((item) => (
                <div key={item.id}
                  className={`py-4  flex justify-center items-center px-8 cursor-pointer  ${tabShowing!==item?.tabName?.[language]?'':'bg-black/20'}`}
                  onClick={() => {
                    setTabShowing(item?.tabName?.[language]);     
                    setCurrentTab(item.comp)
                  }}
                >
                  <label className={`uppercase  cursor-pointer ${tabShowing!==item?.tabName?.[language]?"grey-theme-color":"text-black font-bold"} `}>           
                    {item?.tabName?.[language]}
                  </label>
                </div>
              ))}
            </div>
    </div>
   </>
  )
}

export default Tabs